import { Injectable } from '@angular/core';
import { AuthSession, FetchUserAttributesOutput, fetchAuthSession, fetchUserAttributes, signInWithRedirect } from 'aws-amplify/auth';
import { Observable, defer } from 'rxjs';

import { AuthGateway } from '../usecases/auth.gateway';

@Injectable()
export class AuthService extends AuthGateway {
  fetchAuthSession(forceRefresh = false): Observable<AuthSession> {
    return defer(() => fetchAuthSession({ forceRefresh }));
  }

  fetchUserAttributes(): Observable<FetchUserAttributesOutput> {
    return defer(() => fetchUserAttributes());
  }

  signInWithRedirect(): Observable<void> {
    return defer(() => signInWithRedirect({ provider: { custom: 'Okta-SAML' } }));
  }
}
